import { ToroEnums } from '../../../../common/enumerations/toro.enums';
import SpatialAdjustEntityType = ToroEnums.SpatialAdjustEntityType;

export class LynxPercentAdjust {

    constructor(json: any = null) {
        if (json) {
            Object.assign(this, json);

            // Lynx Cloud API sometimes uses PascalCase and sometimes camelCase
            // Lynx Drive API uses camelCase.
            this.basePercentAdjust = json.BasePercentAdjust ?? json.basePercentAdjust;
            this.display = json.Display ?? json.display;
            this.entityId = json.entityId != null ? new EntityId(json.entityId) : null;
            this.id = json.entityId?.id ?? json.Id;
            this.isPAD = json.IsPAD ?? json.isPAD;
            this.tempDurationDays = json.TempDurationDays ?? json.tempDurationDays;
            this.tempPercentAdjust = json.TempPercentAdjust ?? json.tempPercentAdjust;

            delete this['BasePercentAdjust'];
            delete this['Display'];
            delete this['Id'];
            delete this['IsPAD'];
            delete this['TempDurationDays'];
            delete this['TempPercentAdjust'];
        }
    }

    basePercentAdjust: number;
    display: string;
    id: number;
    isPAD = false;
    tempDurationDays: number;
    tempPercentAdjust: number;

    // Lynx Drive only
    entityId?: EntityId;

}

export class EntityId {
    constructor(json: any = null) {
        if (json) {
            Object.assign(this, json);
        }
    }

    id: number;
    isInvalid: boolean;
    isValid: boolean;
    type: SpatialAdjustEntityType;
}
